const VIEW_PRESETS = {
	perspective: { name: "Perspective View", zoom: 18, pitch: 60, bearing: -30 },
	top: { name: "Top View", zoom: 18, pitch: 0, bearing: 0 },
	north: { name: "North View", zoom: 18, pitch: 80, bearing: 0 },
	east: { name: "East View", zoom: 18, pitch: 80, bearing: 90 },
	south: { name: "South View", zoom: 18, pitch: 80, bearing: 180 },
	west: { name: "West View", zoom: 18, pitch: 80, bearing: 270 },
};

const DEFAULT_VIEW: keyof typeof VIEW_PRESETS = "perspective";

const FIT_BOUNDS_DURATION = 600;

// Earth circumference at the equator, web-mercator flavour. The same value is defined in
// maplibre-connector — it cannot be imported from there without inverting the package dependency.
const EARTH_CIRCUMFERENCE_IN_METERS = 40075016.686;

// The CSS reference pixel is defined as 1/96 inch, which is what turns a map scale into a "1:N" ratio.
const METERS_PER_CSS_PIXEL = 0.0254 / 96;

// The rungs the zoom buttons snap to, so the displayed ratio is always a round cartographic scale.
const SCALE_DENOMINATORS = [50, 100, 200, 500, 1_000, 2_000, 5_000, 10_000, 20_000, 50_000, 100_000, 200_000, 500_000, 1_000_000, 2_000_000];

// MapLibre has no orthographic projection — a near-zero field of view is the closest approximation,
// and it leaves the zoom (and therefore the scale) untouched.
const PERSPECTIVE_FOV = 36.87; // MapLibre's default
const ORTHOGRAPHIC_FOV = 1;

export {
	DEFAULT_VIEW,
	EARTH_CIRCUMFERENCE_IN_METERS,
	FIT_BOUNDS_DURATION,
	METERS_PER_CSS_PIXEL,
	ORTHOGRAPHIC_FOV,
	PERSPECTIVE_FOV,
	SCALE_DENOMINATORS,
	VIEW_PRESETS,
};
